/**
 * Stable UUIDs for financial asset / liability rows in case JSON (persist across saves).
 */

export function newFinancialLineId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    return `line-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function ensureFinancialLineId(existing: string | null | undefined): string {
    if (typeof existing === 'string' && existing.trim() !== '') {
        return existing.trim();
    }
    return newFinancialLineId();
}
